import { makeAutoObservable, runInAction } from 'mobx'
import { userManager } from '@/Core/Managers'
import type { Notify } from '@/Ship/Contracts/Notify'
import { parseApiError } from '@/Ship/Helpers/parseApiError'
import { ChangePasswordTask } from '@/Containers/SettingSection/UserContainer/Tasks/ChangePasswordTask'

/**
 * Local store of ProfileContainer's `ChangePassword` tab.
 *
 * Reuses `ChangePasswordTask` from UserContainer (cross-container import
 * through the public `Tasks/` API, same pattern as InvitationDriverStore →
 * InviteDriverTask in DriverContainer).
 *
 * Owns only the loading flag — form values live in `Core/UI/Form` formContext
 * and are passed into `submit()` by the view.
 */
export class ChangePasswordStore {
    loading = false

    constructor() {
        makeAutoObservable(this)
    }

    async submit(plainPassword: string, notify: Notify): Promise<boolean> {
        const userId = (userManager.user as any)?.uuid as string
        if (!userId) {
            notify.error('Не вдалося визначити ID користувача')
            return false
        }
        this.loading = true
        try {
            await ChangePasswordTask(userId, plainPassword)
            notify.success('Пароль успішно оновлено')
            return true
        } catch (err: any) {
            const parsed = await parseApiError(err)
            notify.error(parsed.message ?? 'Не вдалося оновити пароль')
            return false
        } finally {
            runInAction(() => { this.loading = false })
        }
    }
}
